import httpApiApplication from 'app/http/httpApiApplication';

import { type TaxReturn } from '../types';

export const baseUrlTaxreturns = '/taxreturns';

export const taxReturnService = {
  getTaxReturn: async (id: string): Promise<TaxReturn> => {
    return httpApiApplication.get(baseUrlTaxreturns + '/' + id);
  }
};
